/* dyrektywy */

var ngFormatDate = function () {
    return {
        require: 'ngModel',
        restrict: "A",
        link: function (scope, element, attrs, ngModelCtrl) {
            function formatAsDate(text) {
                var result = "";
                if (typeof text !== "undefined") {
                    try {
                        var date = moment(text);
                        result = date.format("YYYY-MM-DD");
                    } catch (e) {
                        result = "";
                    }
                }
                if (result.toLowerCase() === "invalid date") {
                    result = "";
                }
                return result;
            }
            //ngModelCtrl.$parsers.push(validateEqual);
            ngModelCtrl.$formatters.push(formatAsDate);
        }
    };
};
var ngDatePicker = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            $(function () {
                $(element).datepicker({
                    dateFormat: 'yy-mm-dd',
                    onSelect: function (date) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(date);
                        });
                    }
                });
            });
        }
    };
};
var ngDatePickerToday = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            $(function () {
                $(element).datepicker({
                    dateFormat: 'yy-mm-dd',
                    minDate: 0,
                    onSelect: function (date) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(date);
                        });
                    }
                });
            });
        }
    };
};

var ngPasswordConfirm = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            data: '=ngPasswordConfirm'
        },
        link: function ($scope, $el, $attrs, $ctrl) {

            function validate(text) {
                var valid = (text == $scope.data);
                $ctrl.$setValidity("IsPasswordConfirmed", valid);
                return text;
            }

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

        }
    }
};

var ngCheckNip = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, $el, $attrs, $ctrl) {

            function validatenip(nip) {
                var nip_bez_kresek = nip.replace(/-/g, "");
                var reg = /^[0-9]{10}$/;
                if (reg.test(nip_bez_kresek) == false) {
                    return false;
                } else {
                    var dig = ("" + nip_bez_kresek).split("");
                    var kontrola = (6 * parseInt(dig[0]) + 5 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 2 * parseInt(dig[3]) + 3 * parseInt(dig[4]) + 4 * parseInt(dig[5]) + 5 * parseInt(dig[6]) + 6 * parseInt(dig[7]) + 7 * parseInt(dig[8])) % 11;
                    if (parseInt(dig[9]) == kontrola)
                        return true;
                    else
                        return false;
                }

            }

            function validate(str) {
                str = str || "";
                var valid = validatenip(str);
                $ctrl.$setValidity('checkNIP', valid);
                return str;
            }

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

        }
    }
};

var ngCheckNipRegon = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, $el, $attrs, $ctrl) {

            function validatenip(nip) {
                var no_dashes = nip.replace(/-/g, '');
                var reg = /(^[0-9]{10}$)|(^[0-9]{14}$)|(^[0-9]{9}$)/;
                if (!reg.test(no_dashes)) {
                    return false;
                } else if (no_dashes.length == 10) {
                    var dig = ('' + no_dashes).split('');
                    var kontrola = (
                        6 * parseInt(dig[0]) +
                        5 * parseInt(dig[1]) +
                        7 * parseInt(dig[2]) +
                        2 * parseInt(dig[3]) +
                        3 * parseInt(dig[4]) +
                        4 * parseInt(dig[5]) +
                        5 * parseInt(dig[6]) +
                        6 * parseInt(dig[7]) +
                        7 * parseInt(dig[8])
                    ) % 11;
                    var _kontrola = parseInt(dig[9]);
                    if (_kontrola === kontrola) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (no_dashes.length == 9) {
                    var dig = ('' + no_dashes).split('');
                    var kontrola = (
                        8 * parseInt(dig[0]) +
                        9 * parseInt(dig[1]) +
                        2 * parseInt(dig[2]) +
                        3 * parseInt(dig[3]) +
                        4 * parseInt(dig[4]) +
                        5 * parseInt(dig[5]) +
                        6 * parseInt(dig[6]) +
                        7 * parseInt(dig[7])
                    ) % 11;
                    if (kontrola == 10)
                        kontrola = 0;
                    var _kontrola = parseInt(dig[8]);
                    if (_kontrola === kontrola) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (no_dashes.length == 14) {
                    const dig = ('' + no_dashes).split('');
                    var kontrola = (
                        8 * parseInt(dig[0]) +
                        9 * parseInt(dig[1]) +
                        2 * parseInt(dig[2]) +
                        3 * parseInt(dig[3]) +
                        4 * parseInt(dig[4]) +
                        5 * parseInt(dig[5]) +
                        6 * parseInt(dig[6]) +
                        7 * parseInt(dig[7])
                    ) % 11;
                    if (kontrola == 10)
                        kontrola = 0;
                    var _kontrola = parseInt(dig[8]);
                    if (_kontrola === kontrola) {
                        var __kontrola = (
                            2 * parseInt(dig[0]) +
                            4 * parseInt(dig[1]) +
                            8 * parseInt(dig[2]) +
                            5 * parseInt(dig[3]) +
                            0 * parseInt(dig[4]) +
                            9 * parseInt(dig[5]) +
                            7 * parseInt(dig[6]) +
                            3 * parseInt(dig[7]) +
                            6 * parseInt(dig[8]) +
                            1 * parseInt(dig[9]) +
                            2 * parseInt(dig[10]) +
                            4 * parseInt(dig[11]) +
                            8 * parseInt(dig[12])
                        ) % 11;
                        if (__kontrola == 10)
                            __kontrola = 0;
                        var ___kontrola = parseInt(dig[13]);
                        if (___kontrola === __kontrola) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
            }

            function validate(str) {
                str = str || "";
                var valid = validatenip(str);
                $ctrl.$setValidity('checkNIPREGON', valid);
                return str;
            }

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

        }
    }
};

var ngCheckIsAssignedToCollect = function () {
    var ctrls = [];
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            data: '=ngCheckIsAssignedToCollect'
        },
        link: function ($scope, $el, $attrs, $ctrl) {
            // pobranie tablicy z osobami odpowiedzialnymi
            var arr = $scope.data.items || [];
            var item = $scope.data.item || {};
            var flag = $scope.data.flag || false;


            // walidacja
            function validate(value) {
                var c = 0;
                if (flag) {
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].IsAssignedToCollect && i !== item.idx) {
                            c++;
                        }
                    }
                    if (value) {
                        c++;
                    }
                }
                var valid = true;
                if (flag) {
                    valid = (c > 1);
                }

                if (arr.length == 1)
                    valid = value;

                //ustawinie flagi
                $ctrl.$setValidity('checkIsAssignedToCollect', valid);


                // oddanie wartosci
                return value;
            }

            ctrls.push({ ctrl: $ctrl, validate: validate });

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

            $scope.$watch('data.item.IsAssignedToCollect', function (newValue) {
                ctrls.forEach(function (savedCtrl) {
                    savedCtrl.validate(savedCtrl.ctrl.$viewValue);
                });
                //validate(newValue);
            });
        }
    }
};

var ngChangePesel = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            data: '=ngChangePesel'
        },
        link: function ($scope, $el, $attrs, $ctrl) {
            function validate(value) {
                value = value || "";


                // sprawdzenie
                var result = rozkodujPesel(value);

                if (value === "")
                    result.valid = true;

                // wskazanie daty
                if (value.length >= 6) {

                    $scope.data = moment(result.date).format("YYYYMMDD");
                }

                $ctrl.$setValidity("checkPesel", result.valid);

                return value;
            }


            /*
             * http://porady-it.pl/programowanie/jak-sprawdzic-poprawnosc-numeru-pesel-pobrac-date-urodzenia-oraz-plec/
             */
            function rozkodujPesel(pesel) {
                //pobranie daty
                var rok = parseInt(pesel.substring(0, 2), 10);
                var miesiac = parseInt(pesel.substring(2, 4), 10) - 1;
                var dzien = parseInt(pesel.substring(4, 6), 10);

                if (miesiac >= 80) {
                    rok += 1800;
                    miesiac = miesiac - 80;
                } else if (miesiac >= 60) {
                    rok += 2200;
                    miesiac = miesiac - 60;
                } else if (miesiac >= 40) {
                    rok += 2100;
                    miesiac = miesiac - 40;
                } else if (miesiac >= 20) {
                    rok += 2000;
                    miesiac = miesiac - 20;
                } else {
                    rok += 1900;
                }

                var dataUrodzenia = new Date();
                dataUrodzenia.setFullYear(rok, miesiac, dzien);

                // Weryfikacja numery PESEL
                var wagi = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
                var suma = 0;

                for (var i = 0; i < wagi.length; i++) {
                    suma += (parseInt(pesel.substring(i, i + 1), 10) * wagi[i]);
                }

                suma = suma % 10;

                var cyfraKontr = parseInt(pesel.substring(10, 11), 10);
                var poprawnosc = (suma === cyfraKontr);

                //określenie płci
                var plec = 'k';

                if (parseInt(pesel.substring(9, 10), 10) % 2 === 1) {
                    plec = 'm';
                }

                return {
                    valid: poprawnosc,
                    sex: plec,
                    date: dataUrodzenia
                };
            }

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

        }
    }
};


var ngCheckOwnershipShare = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            data: '=ngCheckOwnershipShare'
        },
        link: function ($scope, $el, $attrs, $ctrl) {

            // pobranie tablicy z osobami odpowiedzialnymi
            var arr = $scope.data.items || [];
            var item = $scope.data.item || {};
            var form = $scope.data.form || {};

            // walidacja
            // jezeli suma wszystkich + wartosc != 100 to blad
            function validate(value) {
                var v = 0;
                var valid = true;
                for (var i = 0; i < arr.length; i++) {
                    if (i !== item.idx) {
                        v += parseFloat(arr[i].OwnershipShare);
                    }
                }
                v += parseFloat(value);
                // test
                valid = (v == parseFloat(100));

                // ustawienie flagi
                form.$setValidity('checkOwnershipShareError', valid);

                // oddanie wartosci
                return value;
            };

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

        }
    }
};



var ngCheckPhone = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, $el, $attrs, $ctrl) {

            function validatePhone(phone) {
                //ll-75
                var phoneNoSemicolon = phone; //.replace(/-/g, "");
                //var reg = /^[\+]{0,1}(?:[0-9] ?){6,14}[0-9]$/; //bez kresek
                var reg = /^[0-9\+]{8,13}$/;
                if (reg.test(phoneNoSemicolon) == false) {
                    return false;
                } else {
                    return true;
                }
            }

            function validate(str) {
                str = str || "";
                var valid = validatePhone(str);
                $ctrl.$setValidity('checkPhone', valid);
                return str;
            }

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);

        }
    }
};



var ngCheckIdDocumentNumber = function ($compile) {
    return {
        restrice: 'A',
        require: 'ngModel',
        scope: {
            documentType: "=ngCheckIdDocumentNumber"

        },
        link: function (scope, $el, $attrs, $ctrl) {

            // walidacje
            function validate(str) {
                str = str || "";
                var valid = false;

                switch ((scope.documentType).toString()) {
                    case "0":
                        valid = validateDO(str);
                        break;
                    case "1":
                        valid = validatePASS(str);
                        break;
                    case "2":
                        valid = true;
                        break;
                    case "3":
                        valid = true;
                        break;
                    default:
                        valid = false;
                        break;
                }

                $ctrl.$setValidity('invalidDocumentNumber', valid);
                return str;
            }

            $ctrl.$formatters.push(validate);
            $ctrl.$parsers.push(validate);


            // obserwowanie zmiennej
            scope.$watch("documentType", function () {
                validate($ctrl.$modelValue);
            }, true);
        }
    }
};


var ngCheckDocumentDate = function () {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, elem, attrs, ctrl) {
            function validate(text) {

                text = (text || "").substring(0, 10).replace(/-/g, "");
                text = text.substring(0, 4) + "-" + text.substring(4, 6) + "-" + text.substring(6, 8);
                var d = new Date(text);

                var valid = false;
                if ("Invalid Date" != d) {
                    var endDate = new Date();
                    var startDate = new Date(endDate.getFullYear() - 10, endDate.getMonth(), endDate.getDay());
                    valid = (startDate <= d && d <= endDate);
                }
                ctrl.$setValidity("invalidDocumentDate", valid);
                return text; //.replace(/-/g,"");
            };



            ctrl.$formatters.push(validate);
            ctrl.$parsers.push(validate);

        }
    }
};

var ngContactPersonRoles = function () {
    return {
        restrict: 'AE',
        scope: {
            person: '='
        },
        template: '<div><div ng-show="person.Opiekun">Opiekun</div><div ng-show="person.Faktury">Faktury</div><div ng-show="person.Prowizje">Prowizje</div><div ng-show="person.Wlasciciel">Wlasciciel</div></div>'
    };
};

var ngBankAccountTypes = function () {
    return {
        restrict: 'AE',
        scope: {
            account: '='
        },
        template: '<div><div ng-show="account.MainType">Główny</div><div ng-show="account.PaymentForItems">Płatność za przedmioty</div><div ng-show="account.PaymentForCommissions">Płatność prowizji</div></div>'
    };
};